module.exports = "<!--The content below is only a placeholder and can be replaced.-->\r\n<!--<div>Dlr timesheet app loading...</div>-->\r\n<router-outlet></router-outlet>\r\n<ng4-loading-spinner> </ng4-loading-spinner>"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main